

































































  import VueCookieToggler from 'vue-cookie-toggler';
  import {Component, Vue } from 'vue-property-decorator';
  import ChangeLang from "@/components/ChangeLang.vue";

  @Component({
    components: {ChangeLang, VueCookieToggler}
  })
  export default class App extends Vue {

    get isLoggedIn(): boolean{
      return this.$store.getters.isLoggedIn;
    }

    logoutUser(){
      this.$store.dispatch('logout');
    }

    get cookiesGroups(){
      return [
        {
          category: this.$i18n.t('CookiesPolicyMessages.essentail.category'),
          name: this.$i18n.t('CookiesPolicyMessages.essentail.name'),
          description:  this.$i18n.t('CookiesPolicyMessages.essentail.description'),
          active: true,
          required: true,
        },
      ];
    }
}
